var React = require('react');

function FirstTriangleSales (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M67.9247 71.2739L95.5232 1.93744L140.706 110.44L67.9247 71.2739Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M3.29471 74.3158L95.6314 1.93214L68.0389 71.1664L3.29471 74.3158Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M3.29688 74.3184L67.9955 71.1712L140.707 110.443L3.29688 74.3184Z","fill":"#5915C7","key":2})]);
}

FirstTriangleSales.defaultProps = {"width":"141","height":"118","viewBox":"0 0 141 118","fill":"none"};

module.exports = FirstTriangleSales;

FirstTriangleSales.default = FirstTriangleSales;
